import React, { useState } from 'react'
import ApTextarea from './ApTextarea'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { AppraisalFormProps } from '../../Interface/EmployeeManager/AppraisalForm/AppraisalForm'
import { AppraisalsType } from 'Models/appraisalsType'
import { AccordionCard } from './AccordionCard/AccordionCard'

interface ApTextareaProps {
  register: UseFormRegister<any> // Replace `any` with your form's data type
  errors?: FieldErrors<AppraisalFormProps>
  appraisal?: AppraisalsType
  isManager: boolean
  activeAccordion?: any
  setActiveAccordion?: any
  inputError?: boolean
  setInputError?: any
  isDisabled?: boolean
}

const ApStepOne: React.FC<ApTextareaProps> = ({
  register,
  errors,
  isManager,
  activeAccordion,
  setActiveAccordion,
  inputError,
  setInputError,
  isDisabled,
}) => {
  return (
    <>
      <AccordionCard
        id={1}
        title='Strengths'
        activeAccordion={activeAccordion}
        setActiveAccordion={setActiveAccordion}
        className='mx-3 mt-4 px-4 pt-3'
      >
        {' '}
        <div className='row'>
          <div className='form-group col-md-12 mt-3'>
            <label htmlFor=''>
              Highlight Strengths that facilitated the performance of key goals for period under
              review
            </label>
            <input
              type='hidden'
              {...register('personalAssessment[0].category')}
              value='Strengths'
            />
            <input
              type='hidden'
              {...register('personalAssessment[0].question')}
              value='Highlight Strengths that facilitated the performance of key
                  goals for period under review'
            />
            <ApTextarea
              name='personalAssessment[0].answer'
              index={0}
              register={register}
              errors={errors}
              rules={{
                required: 'Field is required.',
              }}
              disabled={isDisabled === false ? isDisabled : isManager}
            ></ApTextarea>
          </div>

          <div className='form-group col-md-12 mt-3'>
            <label htmlFor=''>How to further leverage those strengths.</label>
            <input
              type='hidden'
              {...register('personalAssessment[1].category')}
              value='Strengths'
            />
            <input
              type='hidden'
              {...register('personalAssessment[1].question')}
              value='How to further leverage those strengths.'
            />
            <ApTextarea
              name='personalAssessment[1].answer'
              index={1}
              register={register}
              errors={errors}
              rules={{
                required: 'Field is required.',
              }}
              disabled={isDisabled === false ? isDisabled : isManager}
            ></ApTextarea>
          </div>
        </div>{' '}
      </AccordionCard>

      <AccordionCard
        id={2}
        title='Weaknesses'
        activeAccordion={activeAccordion}
        setActiveAccordion={setActiveAccordion}
        className='mx-3 mt-4 px-4 pt-3'
        error={inputError}
      >
        {' '}
        <div className='row'>
          <div className='form-group col-md-12 mt-3'>
            <label htmlFor=''>
              What are the identified weaknesses – areas/tasks that you could handle better and more
              efficiently?
            </label>
            <input
              type='hidden'
              {...register('personalAssessment[2].category')}
              value='Weaknesses'
            />
            <input
              type='hidden'
              {...register('personalAssessment[2].question')}
              value=' What are the identified weaknesses – areas/tasks that you
                  could handle better and more efficiently?'
            />
            <ApTextarea
              name='personalAssessment[2].answer'
              index={2}
              register={register}
              errors={errors}
              rules={{
                required: 'Field is required.',
              }}
              disabled={isDisabled === false ? isDisabled : isManager}
            ></ApTextarea>
          </div>

          <div className='form-group col-md-12 mt-3'>
            <label htmlFor=''>How do you propose to develop those areas?</label>
            <input
              type='hidden'
              {...register('personalAssessment[3].category')}
              value='Weaknesses'
            />
            <input
              type='hidden'
              {...register('personalAssessment[3].question')}
              value=' How do you propose to develop those areas?'
            />
            <ApTextarea
              name='personalAssessment[3].answer'
              index={3}
              register={register}
              errors={errors}
              rules={{
                required: 'Field is required.',
              }}
              disabled={isDisabled === false ? isDisabled : isManager}
            ></ApTextarea>
          </div>
        </div>{' '}
      </AccordionCard>

      <AccordionCard
        id={3}
        title='Role Fit'
        activeAccordion={activeAccordion}
        setActiveAccordion={setActiveAccordion}
        className='mx-3 mt-4 px-4 pt-3'
        error={inputError}
      >
        {' '}
        <div className='row'>
          <div className='form-group col-md-12 mt-3'>
            <label htmlFor=''>Do you think you are a good fit for your role?</label>
            <input type='hidden' {...register('personalAssessment[4].category')} value='Role Fit' />
            <input
              type='hidden'
              {...register('personalAssessment[4].question')}
              value='Do you think you are a good fit for your role?'
            />
            <ApTextarea
              name='personalAssessment[4].answer'
              index={4}
              register={register}
              errors={errors}
              rules={{
                required: 'Field is required.',
              }}
              disabled={isDisabled === false ? isDisabled : isManager}
            ></ApTextarea>
          </div>

          <div className='form-group col-md-12 mt-3'>
            <label htmlFor=''>What other role do you think you can perform better in?</label>
            <input type='hidden' {...register('personalAssessment[5].category')} value='Role Fit' />
            <input
              type='hidden'
              {...register('personalAssessment[5].question')}
              value='What other role do you think you can perform better in?'
            />

            <ApTextarea
              name='personalAssessment[5].answer'
              index={5}
              register={register}
              errors={errors}
              rules={{
                required: 'Field is required.',
              }}
              disabled={isDisabled === false ? isDisabled : isManager}
            ></ApTextarea>
          </div>

          <div className='form-group col-md-12 mt-3'>
            <label htmlFor=''>Is your current role in line with your career plan?</label>
            <input type='hidden' {...register('personalAssessment[6].category')} value='Role Fit' />
            <input
              type='hidden'
              {...register('personalAssessment[6].question')}
              value='Is your current role in line with your career plan?'
            />
            <ApTextarea
              name='personalAssessment[6].answer'
              index={6}
              register={register}
              errors={errors}
              rules={{
                required: 'Field is required.',
              }}
              disabled={isDisabled === false ? isDisabled : isManager}
            ></ApTextarea>
          </div>
        </div>{' '}
      </AccordionCard>

      <AccordionCard
        id={5}
        title='Engagement'
        activeAccordion={activeAccordion}
        setActiveAccordion={setActiveAccordion}
        className='mx-3 mt-4 px-4 pt-3'
        error={inputError}
      >
        {' '}
        <div className='row'>
          <div className='form-group col-md-12 mt-3'>
            <label htmlFor=''>How engaged are you in your current role?</label>
            <input
              type='hidden'
              {...register('personalAssessment[7].category')}
              value='Engagement'
            />
            <input
              type='hidden'
              {...register('personalAssessment[7].question')}
              value='Is your current role in line with your career plan?'
            />
            <ApTextarea
              name='personalAssessment[7].answer'
              index={7}
              register={register}
              errors={errors}
              rules={{
                required: 'Field is required.',
              }}
              disabled={isDisabled === false ? isDisabled : isManager}
            ></ApTextarea>
          </div>

          <div className='form-group col-md-12 mt-3'>
            <label htmlFor=''>What motivates or demotivates you?</label>
            <input
              type='hidden'
              {...register('personalAssessment[8].category')}
              value='Engagement'
            />
            <input
              type='hidden'
              {...register('personalAssessment[8].question')}
              value='What motivates or demotivates you?'
            />
            <ApTextarea
              name='personalAssessment[8].answer'
              index={8}
              register={register}
              errors={errors}
              rules={{
                required: 'Field is required.',
              }}
              disabled={isDisabled === false ? isDisabled : isManager}
            ></ApTextarea>
          </div>

          <div className='form-group col-md-12 mt-3'>
            <label htmlFor=''>How can you be further engaged?</label>
            <input
              type='hidden'
              {...register('personalAssessment[9].category')}
              value='Engagement'
            />
            <input
              type='hidden'
              {...register('personalAssessment[9].question')}
              value='How can you be further engaged?'
            />
            <ApTextarea
              name='personalAssessment[9].answer'
              index={9}
              register={register}
              errors={errors}
              rules={{
                required: 'Field is required.',
              }}
              disabled={isDisabled === false ? isDisabled : isManager}
            ></ApTextarea>
          </div>
        </div>{' '}
      </AccordionCard>

      <AccordionCard
        id={6}
        title='Previous Improvement Plan'
        activeAccordion={activeAccordion}
        setActiveAccordion={setActiveAccordion}
        className='mx-3 mt-4 px-4 pt-3'
        error={inputError}
      >
        {' '}
        <div className='row'>
          <div className='form-group col-md-12 mt-3'>
            <label htmlFor=''>What were you required to improve upon at the last appraisal?</label>
            <input
              type='hidden'
              {...register('personalAssessment[10].category')}
              value='Previous Improvement Plan'
            />
            <input
              type='hidden'
              {...register('personalAssessment[10].question')}
              value=' What were you required to improve upon at the last appraisal?'
            />
            <ApTextarea
              name='personalAssessment[10].answer'
              index={10}
              register={register}
              errors={errors}
              rules={{
                required: 'Field is required.',
              }}
              disabled={isDisabled === false ? isDisabled : isManager}
            ></ApTextarea>
          </div>

          <div className='form-group col-md-12 mt-3'>
            <label htmlFor=''>What have you done differently to improve those areas?</label>
            <input
              type='hidden'
              {...register('personalAssessment[11].category')}
              value='Previous Improvement Plan'
            />
            <input
              type='hidden'
              {...register('personalAssessment[11].question')}
              value='What have you done differently to improve those areas?'
            />
            <ApTextarea
              name='personalAssessment[11].answer'
              index={11}
              register={register}
              errors={errors}
              rules={{
                required: 'Field is required.',
              }}
              disabled={isDisabled === false ? isDisabled : isManager}
            ></ApTextarea>
          </div>
        </div>{' '}
      </AccordionCard>
    </>
  )
}

export default ApStepOne
